Vendd.Scripts.load(function () {
    if ($('.back-to-top').length > 0) {
        backToTop();
    }

    if (isTouch()) {
        initFooterMenuToggle();
    }
    if ($('.promo-pop-up').length > 0) {
        initPromoPopUpFooter();
    }
});
function initPromoPopUpFooter() {
    var funcCookiesEnabledPromo = true;
    if (window.ConsentsManager) {
        funcCookiesEnabledPromo = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }
    var $wrapper = $('.promo-pop-up');
    if ($wrapper.length < 1 || !funcCookiesEnabledPromo)
        return;

    var cookiesAcceptedPromo = window.ConsentsManager.cookiesStatus.userHasSetCookies;
    var promoPopUp = Cookies.get('promoPopUp');

    if (!promoPopUp  && cookiesAcceptedPromo && $('.terms-page.consents-page').length <= 0) {
        $wrapper.show();
        $('html, body').addClass('no-scroll');
        $('.header-overlay').addClass('visible');
        $('.js-promo-close',$wrapper).click(function () {
            $wrapper.hide();
            $('.header-overlay').removeClass('visible');
            $('html, body').removeClass('no-scroll');
            Cookies.set("promoPopUp", true, { expires: 5, samesite: 'Lax' });
        });

    }

}
function backToTop() {
    var $backToTop = $(".back-to-top"),
    scroll;

    scroll = $(window).scrollTop();
    scroll > 500 ? $backToTop.addClass("visible") : $backToTop.removeClass("visible");
    $(window).scroll($.debounce(200, function () {
        scroll = $(window).scrollTop();
        scroll > 500 ? $backToTop.addClass("visible") : $backToTop.removeClass("visible")
    }));

    $backToTop.on("click", function () {
        $("body,html").animate({ scrollTop: 0 }, 400, 'swing');
    });
}

function initFooterMenuToggle() {
    var mainCont = $('.footer-template-one .region-area-two');
    $(".footer-template-one .js-toggle").click(function () {
        var hiddenCont = $(this).siblings('.js-content-accord');
        $(this).toggleClass('icon-arrow1_down icon-arrow1_up');
        if (hiddenCont.hasClass('opened')) {
            hiddenCont.removeClass('opened');
        } else {
            mainCont.find('.opened').removeClass('opened').siblings('.js-toggle').toggleClass('icon-arrow1_down icon-arrow1_up');
            hiddenCont.addClass('opened');
        }
    });

    var accordion = false;

    if ($(window).outerWidth() <= 767) {
        accordion = true;
    }

    $(window).resize(function () {
        if ($(window).outerWidth() > 767) {
            if (accordion) {
                $('.js-content-accord', mainCont).removeClass('opened');
                accordion = false;
            }
        }
        else {
            if (!accordion) {
                $('.js-content-accord', mainCont).siblings('.js-toggle').addClass('icon-arrow-down').removeClass('icon-arrow-up');
                accordion = true;
            }
        }
    });
}